import React, { useEffect, useState } from "react";
import { Button, Grid, Table } from "@mui/material";
import { Box, display } from "@mui/system";
import CustomDatePicker from "../../../../common/CustomDatePicker";
import MultiSelectDropDown from "../../../../form-components/MultiSelectDropDownComponent";
import ReportHeader from "../../../../common/ReportHeader";
import {
  clickElement,
  focusElemnt,
  formatDate,
  navigation1,
  navigation3,
} from "../../../../../utilityFunctions";
import jsPDF from "jspdf";
import { callAddFontRobotoNormal } from "../../../../../assets/fonts/Roboto-normal";
import { callAddFontRobotoBold } from "../../../../../assets/fonts/Roboto-bold";
import autoTable from "jspdf-autotable";
import {
  jsPdfDidParseCellCallback,
  jsPdfWillDrawCellCallback,
} from "../../../../generics/helper";
import excelExport from "../../../../../assets/extra/export-excel";
import ReactHtmlTableToExcel from "react-html-table-to-excel";
import { excelConfig } from "../../../../../assets/extra/excelConfig";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { generalReportMenu, reportMenu } from "../../../../../redux/Actions";
import Alert from "../../../../common/Alert";
import PosTransactionReportTable from "./PosTransactionReportTable";
import {
  getBusStationListAll,
  getUserList,
} from "../../../../../redux/KSRTC_Redux/userConfig/UserAction";
import { getPOSTransactionReport } from "../../../../../redux/KSRTC_Redux/ReportsPage/ReportsAction";
import ExcelTable from "./ExcelTable";

const PosTransactionReport = () => {
  const dispatch = useDispatch();
  const store = useSelector((store) => store);
  const { user, userConfig } = store;
  const { busStationList } = useSelector((store) => store.masterConfig);
  const userState = useSelector((store) => store.user);
  const [isPdfLoaded, setIsPdfLoaded] = useState(false);
  const LoginId = sessionStorage.getItem("LoginId");
  const [filterUserList, setFilterUserList] = useState([]);
  const [selUser, setSelUser] = useState([]);
  const [busStationData, setBusStationData] = useState([]);
  const [isPdfLoading, setIsPdfLoading] = useState(false);
  const [fromDate, setFromDate] = useState(
    formatDate(window.getTime ? window.getTime() : new Date())
  );
  const [toDate, setToDate] = useState(
    formatDate(window.getTime ? window.getTime() : new Date())
  );
  const [disableUserList, setDisableUserList] = useState(false);
  const [selectedData, setSelectedData] = useState({
    station: [],
    fromDate: formatDate(window.getTime ? window.getTime() : new Date()),
    toDate: formatDate(window.getTime ? window.getTime() : new Date()),
  });
  const [reportTableData, setReportTableData] = useState({});
  const [showReport, setShowReport] = useState(false);

  const handleResetValue = () => {
    defaultSelected()
  };

  useEffect(() => {
    const userBody = {
      CompanyID: user?.CompanyID,
      UserID: 0,
      BranchID: 0,
    };
    dispatch(getUserList(userBody, true, 60 * 60 * 1000));

    const busStationBody = {
      CompanyID: userState?.CompanyID,
      BranchID: 0,
      IsOutStation: -1,
    };
    dispatch(getBusStationListAll(busStationBody, true, 60 * 60 * 1000));
  }, []);

  useEffect(() => {
    if (userConfig?.userList?.length > 0) {
      defaultSelected()
    }
  }, [busStationList, userConfig?.userList]);

  const defaultSelected = () => {
    let temp = userConfig?.userList?.filter(
      (item) => item.CounterTypeID === 1
    ); //only franchisee user
    const addLoginIdToUser = temp?.map((val) => ({
      ...val,
      UserName: `${val.UserName}(${val.LoginID} )`,
    }));
    let filteredList = addLoginIdToUser?.filter(
      (val) => val.UserID === user?.UserID
    );
    if (busStationList?.length > 0) {
      if (filteredList?.length === 1) {
        const addBusStationCode = busStationList
          ?.map((val) => ({
            ...val,
            BranchName: `${val.BranchName} (${val.BranchCode})`,
          }))
          ?.filter(
            (val) =>
              Number(val?.BranchID) ===
              Number(filteredList?.[0]?.AccessBranchID) ||
              Number(filteredList?.[0]?.AccessBranchID) === 0
          );
        setBusStationData(busStationList);
        setSelectedData((prev) => ({ ...prev, station: addBusStationCode }));
      } else {
        setBusStationData(busStationList);
        setSelectedData((prev) => ({ ...prev, station: busStationList }));
      }
    }
    setFilterUserList(addLoginIdToUser);
    if (filteredList?.length > 0) {
      setDisableUserList(true);
      setSelUser(filteredList);
    } else {
      setDisableUserList(false);
      setSelUser(addLoginIdToUser);
    }
  }

  const handleStation = (val) => {
    if (val.length === 1) {
      setSelectedData((prev) => ({
        ...prev,
        station: val,
      }));
    }
  };

  const userNameProps = () => {
    return {
      id: "userName",
      width: "100%",
      name: "userName",
      label: "",
      isCompulsory: false,
      options: filterUserList || [],
      preSelectedValues: selUser || [],
      searchPlaceholder: "Search by User Name",
      disabled: disableUserList,
      isObject: true,
      primaryKey: "UserID",
      labelKey: "UserName",
      singleSelect: true,
      selectAllOption: true,
      defaultAllSelected: true,
      searchByCode: true,
      searchByName: "LoginID",
      prevId: "",
      nextId: "station",
    };
  };

  const stationProps = () => {
    return {
      id: "station",
      width: "100%",
      name: "station",
      label: "",
      isCompulsory: false,
      options: busStationData || [],
      preSelectedValues: selectedData?.station || [],
      searchPlaceholder: "Search by Station",
      disabled:
        Number(selUser?.[0]?.AccessBranchID) === 0 || selUser.length > 1 ? false : true,
      isObject: true,
      primaryKey: "BranchID",
      labelKey: "BranchName",
      singleSelect: true,
      selectAllOption: true,
      defaultAllSelected: true,
      prevId: "userName",
      nextId: "fromCancelDate",
      searchByCode: true,
      searchByName: "BranchCode",
    };
  };

  const columnDefsTwo = [
    {
      headerName: "Txn. Date",
      field: "TxnDate",
      exportHead: "Txn. Date",
      xlCol: { dataType: "string", dataFormatter: null },
      headerSx: { textAlign: "left" },
      showFilter: true,
    },
    {
      headerName: "Time",
      field: "TxnTime",
      exportHead: "Time",
      xlCol: { dataType: "string", dataFormatter: null },
      headerSx: { textAlign: "left" },
      showFilter: true,
    },
    {
      headerName: "OB Ref.",
      field: "OBRefno",
      exportHead: "OB Ref.",
      xlCol: { dataType: "string", dataFormatter: null },
      headerSx: { textAlign: "left" },
      showFilter: true,
    },
    {
      headerName: "POS Txn. ID",
      field: "PGTransactionID",
      exportHead: "POS Txn. ID",
      xlCol: { dataType: "string", dataFormatter: null },
      headerSx: { textAlign: "left" },
      showFilter: true,
    },
    {
      headerName: "Amount",
      field: "Amount",
      exportHead: "Amount",
      xlCol: { dataType: "number", dataFormatter: null },
      headerSx: { textAlign: "right" },
      showFilter: true,
    },
    {
      headerName: "PNR No.",
      field: "PNRNo",
      exportHead: "PNR No.",
      xlCol: { dataType: "string", dataFormatter: null },
      headerSx: { textAlign: "left" },
      showFilter: true,
    },
    {
      headerName: "Ticket No.",
      field: "TktNo",
      exportHead: "Ticket No.",
      xlCol: { dataType: "number", dataFormatter: null },
      headerSx: { textAlign: "right" },
      showFilter: true,
    },
    {
      headerName: "DOJ",
      field: "JourneyDate",
      exportHead: "DOJ",
      xlCol: { dataType: "string", dataFormatter: null },
      headerSx: { textAlign: "left" },
      showFilter: true,
    },
    {
      headerName: "User",
      field: "User",
      exportHead: "User",
      xlCol: { dataType: "string", dataFormatter: null },
      headerSx: { textAlign: "left" },
      showFilter: true,
    },
    {
      headerName: "Counter",
      field: "CounterCode",
      exportHead: "Counter",
      xlCol: { dataType: "string", dataFormatter: null },
      headerSx: { textAlign: "left" },
      showFilter: true,
    },
    {
      headerName: "Station",
      field: "BusStation",
      exportHead: "Station",
      xlCol: { dataType: "string", dataFormatter: null },
      headerSx: { textAlign: "left" },
      showFilter: true,
    },
    {
      headerName: "POS Device ID",
      field: "POSDeviceID",
      exportHead: "POS Device ID",
      xlCol: { dataType: "string", dataFormatter: null },
      headerSx: { textAlign: "left" },
      showFilter: true,
    },
    {
      headerName: "Txn",
      field: "ModificationTypeName",
      exportHead: "Txn",
      xlCol: { dataType: "string", dataFormatter: null },
      headerSx: { textAlign: "left" },
      showFilter: true,
    },
  ];

  const columnDefsThree = [];
  let count = 12;
  for (let i = 1; i <= count; i++) {
    columnDefsThree.push({
      headerName: "",
      exportHead: "",
      field: "",
      xlCol: { dataType: "number", dataFormatter: null },
      headerSx: {},
      allowSorting: true,
    });
  }
  const summaryDataTwo = [
    {
      isSubHeadingRow: true,
      subHeadingData: [
        {
          caption: "Booked Transaction Details",
          value: "",
          colSpan: 13,
          align: "left",
        },
      ],
    },
  ];
  const summaryDataThree = [
    {
      isSubHeadingRow: true,
      subHeadingData: [
        {
          caption: "KSTDC POS Transaction",
          value: "",
          colSpan: 13,
          align: "left",
        },
      ],
    },
  ];

  // for Export as excel
  const reportExcelExport = async (reportData, param) => {
    try {
      const xlColumns = columnDefsThree.map((col) => {
        return {
          colHeader: col.exportHead,
          field: col.field,
          xlCol: col.xlCol,
        };
      });
      const summaryColumns = columnDefsTwo.map((col) => {
        return {
          colHeader: col.exportHead,
          field: col.field,
          xlCol: col.xlCol,
        };
      });

      const xlConfig = {
        ...excelConfig,
        columns: xlColumns,
        summaryColumns: summaryColumns,
        fileName: `POS_Transaction_Report.${param}`,
        showFilterSection: true,
        showSummarySection: true,
        showEmptyRow: true,
        headerRowStyle: { fill: "", bold: true },
        borderStyle: {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        },
        showHeader: true,
        workSheetTitle: `POS_Transaction_Report`,
        headerFooter: {
          firstHeader: "POS_Transaction_Report",
          firstFooter: "POS_Transaction_Report",
        },
        sheetHeaderData: [
          {
            caption: "KARNATAKA STATE ROAD TRANSPORT CORPORATION",
            colSpan: 13,
            horizontal: "center",
            newRow: true,
          },
          {
            caption: "POS Transaction Report",
            colSpan: 13,
            size: 12,
            horizontal: "center",
            newRow: true,
          },
          {
            caption: `User : ${user?.UserName} (${LoginId})`,
            value: "",
            colSpan: 13,
            horizontal: "right",
            size: 10,
            newRow: true,
          },
          {
            caption: `Date : ${moment(fromDate).format(
              "DD-MMM-YYYY"
            )} - To ${moment(toDate).format("DD-MMM-YYYY")} `,
            value: ``,
            colSpan: 6,
            size: 10,
          },
          {
            caption: `Print Date & Time : ${moment(
              window.getTime ? window.getTime() : new Date()
            ).format("DD-MMM-YYYY HH:mm")}`,
            value: "",
            colSpan: 7,
            horizontal: "right",
            size: 10,
          },
        ],
      };
      await excelExport.processExcel(xlConfig, summaryDataThree, reportData);
    } catch (err) {
      console.log(err);
    }
  };

  // for Export as Pdf and Print
  const printReport = (reportData, reportData1, param = "pdf") => {
    try {
      setIsPdfLoaded(false);

      const cancellationColumns = columnDefsTwo.map((col) => {
        return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol };
      });

      jsPDF.API.events.push(["addFonts", callAddFontRobotoBold]);
      jsPDF.API.events.push(["addFonts", callAddFontRobotoNormal]);

      const doc = new jsPDF({
        orientation: "l",
        format: "a4",
      });

      var totalPagesExp = "{total_pages_count_string}";
      doc.autoTableSetDefaults({
        headStyles: { fontSize: 8, halign: "left", fillColor: [30, 89, 167] },
      });

      const startY = 10;

      // Add the text at the top of the page
      doc.setFontSize(14);
      doc.setTextColor("#000000");
      doc.setFont("Roboto", "bold");
      doc.text(`KARNATAKA STATE ROAD TRANSPORT CORPORATION`, 90, startY);

      doc.setFont("Roboto", "normal");
      doc.setFontSize(10);
      doc.setTextColor("#000000");
      doc.text(`POS Transaction Report`, 130, startY + 8);

      doc.setFontSize(10);
      doc.setTextColor("#000000");
      doc.text(
        `User: ${user?.UserName || ""} (${sessionStorage.getItem("LoginId") || ""
        })`,
        doc.internal.pageSize.width - 5,
        startY + 14,
        "right"
      );
      doc.text(
        `Date: ${moment(fromDate).format("DD-MMM-YYYY")} -To ${moment(
          toDate
        ).format("DD-MMM-YYYY")}`,
        5,
        startY + 20
      );
      doc.text(
        `Print Date & Time : ${moment(
          window.getTime ? window.getTime() : new Date()
        ).format("DD-MMM-YYYY HH:mm")}`,
        doc.internal.pageSize.width - 5,
        startY + 20,
        "right"
      );

      // Print the table on the first page
      autoTable(doc, {
        startY: startY + 32,
        margin: { top: 3, left: 5, right: 5, bottom: 3 },
        tableWidth: "auto",
        columns: cancellationColumns,
        body: [...summaryDataTwo],
        columnStyles: {
          0: { halign: "left", fontSize: 7 },
          1: { halign: "left", fontSize: 7 },
          2: { halign: "right", fontSize: 7 },
          3: { halign: "right", fontSize: 7 },
          4: { halign: "right", fontSize: 7 },
          5: { halign: "right", fontSize: 7 },
          6: { halign: "right", fontSize: 7 },
          7: { halign: "right", fontSize: 7 },
          8: { halign: "right", fontSize: 7 },
          9: { halign: "right", fontSize: 7 },

        },
        theme: "grid",
        showHead: "never",
        headStyles: {
          fillColor: null,
          textColor: [0, 0, 0],
          lineWidth: 0.2,
        },
        didParseCell: (data) => {
          jsPdfDidParseCellCallback(data, cancellationColumns, []);
        },
        willDrawCell: (data) => {
          jsPdfWillDrawCellCallback(data, true);
        },
        didDrawPage: function (data) {
          data.settings.margin.top = 16;
        },
        pageBreak: "auto",
      });

      autoTable(doc, {
        startY: doc.lastAutoTable.finalY,
        margin: { top: 3, left: 5, right: 5, bottom: 3 },
        tableWidth: "auto",
        columns: cancellationColumns,
        body: reportData,
        columnStyles: {
          0: { halign: "left", fontSize: 7 },
          1: { halign: "left", fontSize: 7 },
          2: { halign: "left", fontSize: 7 },
          3: { halign: "left", fontSize: 7 },
          4: { halign: "right", fontSize: 7 },
          5: { halign: "left", fontSize: 7 },
          6: { halign: "right", fontSize: 7 },
          7: { halign: "left", fontSize: 7 },
          8: { halign: "left", fontSize: 7 },
          9: { halign: "left", fontSize: 7 },
          10: { halign: "left", fontSize: 7 },
          11: { halign: "left", fontSize: 7 },
          12: { halign: "left", fontSize: 7 },

        },
        theme: "grid",
        headStyles: {
          fillColor: null,
          textColor: [0, 0, 0],
          lineWidth: 0.2,
        },
        didParseCell: (data) => {
          jsPdfDidParseCellCallback(data, cancellationColumns, []);
        },
        willDrawCell: (data) => {
          jsPdfWillDrawCellCallback(data, true);
        },
        didDrawPage: function (data) {
          data.settings.margin.top = 16;
        },
        pageBreak: "auto",
      });
      autoTable(doc, {
        startY: doc.lastAutoTable.finalY + 10,
        margin: { top: 3, left: 5, right: 5, bottom: 3 },
        tableWidth: "auto",
        columns: cancellationColumns,
        body: [...summaryDataThree],
        columnStyles: {
          0: { halign: "left", fontSize: 7 },
          1: { halign: "left", fontSize: 7 },
          2: { halign: "right", fontSize: 7 },
          3: { halign: "right", fontSize: 7 },
          4: { halign: "right", fontSize: 7 },
          5: { halign: "right", fontSize: 7 },
          6: { halign: "right", fontSize: 7 },
          7: { halign: "right", fontSize: 7 },
          8: { halign: "right", fontSize: 7 },
        },
        theme: "grid",
        showHead: "never",
        headStyles: {
          fillColor: null,
          textColor: [0, 0, 0],
          lineWidth: 0.2,
        },
        didParseCell: (data) => {
          jsPdfDidParseCellCallback(data, cancellationColumns, []);
        },
        willDrawCell: (data) => {
          jsPdfWillDrawCellCallback(data, true);
        },
        didDrawPage: function (data) {
          data.settings.margin.top = 16;
        },
        pageBreak: "auto",
      });

      autoTable(doc, {
        startY: doc.lastAutoTable.finalY,
        margin: { top: 3, left: 5, right: 5, bottom: 3 },
        tableWidth: "auto",
        columns: cancellationColumns,
        body: reportData1,
        columnStyles: {
          0: { halign: "left", fontSize: 7 },
          1: { halign: "left", fontSize: 7 },
          2: { halign: "left", fontSize: 7 },
          3: { halign: "left", fontSize: 7 },
          4: { halign: "right", fontSize: 7 },
          5: { halign: "left", fontSize: 7 },
          6: { halign: "right", fontSize: 7 },
          7: { halign: "left", fontSize: 7 },
          8: { halign: "left", fontSize: 7 },
          9: { halign: "left", fontSize: 7 },
          10: { halign: "left", fontSize: 7 },
          11: { halign: "left", fontSize: 7 },
          12: { halign: "left", fontSize: 7 },

        },
        theme: "grid",
        headStyles: {
          fillColor: null,
          textColor: [0, 0, 0],
          lineWidth: 0.2,
        },
        didParseCell: (data) => {
          jsPdfDidParseCellCallback(data, cancellationColumns, []);
        },
        willDrawCell: (data) => {
          jsPdfWillDrawCellCallback(data, true);
        },
        didDrawPage: function (data) {
          data.settings.margin.top = 16;
        },
        pageBreak: "auto",
      });
      if (typeof doc.putTotalPages === "function") {
        doc.putTotalPages(totalPagesExp);
      }

      if (param === "print") {
        setIsPdfLoaded(false);
        const pdfBlob = new Blob([doc.output("blob")], {
          type: "application/pdf",
        });
        const pdfUrl = URL.createObjectURL(pdfBlob);
        window.open(pdfUrl);
      } else {
        setIsPdfLoaded(false);
        const pdfData = doc.output("blob");
        const pdfUrl = URL.createObjectURL(pdfData);
        const link = document.createElement("a");
        link.href = pdfUrl;
        link.download = "POS_Transaction_Report.pdf";
        link.click();
      }
    } catch (error) {
      console.log("Error: ", error);
      setIsPdfLoaded(false);
    }
  };
  useEffect(() => {
    focusElemnt("userName");
  }, []);

  const [showAlert, setShowAlert] = useState(false);
  const [alertMsg, setAlertMsg] = useState("");
  const [alertType, setAlertType] = useState("error");
  const handleSetAlert = (msg) => {
    setAlertType("error");
    setAlertMsg(msg);
    setShowAlert(true);
  };
  const handleAlertClose = () => {
    setShowAlert(false);
  };

  const handleSumbit = (id, param) => {
    try {
      const headerData = {
        fromDate: moment(fromDate).format("DD-MMM-YYYY"),
        toDate: moment(toDate).format("DD-MMM-YYYY"),
        user:
          selUser?.length > 0
            ? selUser?.length === 1
              ? selUser[0]?.UserName
              : "All"
            : "All",
        station:
          selectedData?.station?.length > 0
            ? selectedData?.station?.length === 1
              ? selectedData?.station[0]?.BranchName
              : "All"
            : "All",
      };
      const obj = {
        UserID:
          selUser?.length > 0
            ? selUser?.length === 1
              ? selUser[0]?.UserID
              : 0
            : 0,
        BranchID:
          selectedData?.station?.length > 1
            ? 0
            : selectedData?.station?.[0]?.BranchID,
        FromDate: fromDate,
        CounterID: 0,
        ToDate: toDate,
      };
      dispatch(getPOSTransactionReport(obj)).then((res) => {
        if (res?.status === 200 && res?.data?.status) {
          const objArr = Array.isArray(res?.data?.Data?.Table) ? res.data.Data.Table : [];
          const objArr1 = Array.isArray(res?.data?.Data?.Table1) ? res.data.Data.Table1 : [];

          const newData = objArr.map((item) => ({
            ...item,
            isDataRow: true,
            JourneyDate: moment(item.JourneyDate).format("DD-MMM-YYYY"),
          }));

          const totalAmount = objArr.reduce((acc, cur) => acc + Number(cur.Amount), 0);

          const reportData = [
            ...newData,
            ...(objArr.length > 0
              ? [{
                isTotalRow: true,
                totalCaption: "Total",
                colSpan: 4,
                totalCaptionAllignment: "right",
                Amount: totalAmount,
              }]
              : []),
          ];

          const newData1 = objArr1.map((item) => ({
            ...item,
            isDataRow: true,
            JourneyDate: moment(item.JourneyDate).format("DD-MMM-YYYY"),
          }));

          const totalAmount1 = objArr1.reduce((acc, cur) => acc + Number(cur.Amount), 0);

          const reportData1 = [
            ...newData1,
            ...(objArr1.length > 0
              ? [{
                isTotalRow: true,
                totalCaption: "Total",
                colSpan: 4,
                totalCaptionAllignment: "right",
                Amount: totalAmount1,
              }]
              : []),
          ];

          // const objArr = res?.data?.Data?.Table;
          // const objArr1 = res?.data?.Data?.Table1;
          // const newData = objArr.map((item) => ({
          //   ...item,
          //   isDataRow: true,
          //   JourneyDate: moment(item.JourneyDate).format("DD-MMM-YYYY"),
          // }));
          // const totalAmount = objArr.reduce(
          //   (acc, cur) => acc + Number(cur.Amount),
          //   0
          // );
          // const reportData = [
          //   ...newData,
          //   {
          //     isTotalRow: true,
          //     totalCaption: "Total",
          //     colSpan: 4,
          //     totalCaptionAllignment: "right",
          //     Amount: totalAmount,
          //   },
          // ];
          // const newData1 = objArr1.map((item) => ({
          //   ...item,
          //   isDataRow: true,
          //   JourneyDate: moment(item.JourneyDate).format("DD-MMM-YYYY"),
          // }));
          // const totalAmount1 = objArr1.reduce(
          //   (acc, cur) => acc + Number(cur.Amount),
          //   0
          // );
          // const reportData1 = [
          //   ...newData1,
          //   {
          //     isTotalRow: true,
          //     totalCaption: "Total",
          //     colSpan: 4,
          //     totalCaptionAllignment: "right",
          //     Amount: totalAmount1,
          //   },
          // ];

          setReportTableData({ data: reportData, header: headerData, data1: reportData1 });

          if (id === 1) {
            printReport(reportData, reportData1);
          } else if (id === 2) {
            // reportExcelExport(reportData, param);
            setTimeout(() => {
              document.getElementById("excelButton").click();
            }, 1000);

          } else {
            setShowReport(true);
            setReportTableData({ data: reportData, header: headerData, data1: reportData1 });
          }
        } else {
          //error
          handleSetAlert("error", res?.data?.Message);
        }
      });
    } catch (error) {
      console.log("Error: ", error);
      setIsPdfLoading(false);
      setIsPdfLoaded(false);
    }
  };

  return (
    <>
      <Box>
        {!showReport ? (
          <>
            <ReportHeader
              mainHeaderName="Report"
              headerName="General Report"
              openSubMenu={() => dispatch(reportMenu(true))}
              subHeader={"POS Transaction Report"}
              subHeaderVisible={() => dispatch(generalReportMenu(true))}
            />
            <Grid
              container
              spacing={0}
              className="column-container"
              style={{
                padding: "16px 16px 58px 16px",
              }}
            >
              <Grid
                item
                md={6.5}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "16px",
                }}
              >
                <Grid
                  container
                  direction="row"
                  style={{
                    paddingRight: "30px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Grid item md={4} style={{ fontWeight: "600" }}>
                    Username
                  </Grid>
                  <Grid item md={8}>
                    <MultiSelectDropDown
                      id="username"
                      {...userNameProps()}
                      onSelect={(val) => {
                        setSelUser(val);
                        if (val.length === 1) {
                          let busStation = busStationList?.filter((obj) => {
                            return obj?.BranchID === Number(val[0]?.AccessBranchID) || Number(val[0]?.AccessBranchID) === 0
                          })
                          setSelectedData((prev) => ({ ...prev, station: busStation }));
                        } else {
                          setSelectedData((prev) => ({ ...prev, station: busStationList }));
                        }
                      }}
                    />
                  </Grid>
                </Grid>
                <Grid
                  container
                  direction="row"
                  style={{
                    paddingRight: "30px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Grid item md={4} style={{ fontWeight: "600" }}>
                    User Station
                  </Grid>
                  <Grid item md={8}>
                    <MultiSelectDropDown
                      {...stationProps()}
                      onSelect={(val) => {
                        handleStation(val);
                      }}
                    />
                  </Grid>
                </Grid>
                <Grid
                  container
                  direction="row"
                  style={{
                    paddingRight: "30px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Grid item md={4} style={{ fontWeight: "600" }}>
                    From Date
                  </Grid>
                  <Grid item md={8}>
                    <CustomDatePicker
                      id={`fromCancelDate`}
                      label={""}
                      selectedDate={fromDate}
                      minDate={"2024-06-19"}
                      onChange={(value) => {
                        if (new Date(value) < new Date(toDate)) {
                          setFromDate(formatDate(value));
                        } else {
                          setFromDate(formatDate(value));
                          setToDate(formatDate(value));
                        }
                      }}
                      onKeyDown={(e) => {
                        navigation1(e, "toCancelDate", "station");
                      }}
                    />
                  </Grid>
                </Grid>
                <Grid
                  container
                  direction="row"
                  style={{
                    paddingRight: "30px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Grid item md={4} style={{ fontWeight: "600" }}>
                    To Date
                  </Grid>
                  <Grid item md={8}>
                    <CustomDatePicker
                      label={""}
                      id={`toCancelDate`}
                      selectedDate={toDate}
                      onChange={(value) => {
                        setToDate(formatDate(value));
                      }}
                      onKeyDown={(e) => {
                        navigation1(e, "submitButton", "fromCancelDate");
                      }}
                      minDate={fromDate}
                    />
                  </Grid>
                </Grid>

                <Grid
                  container
                  direction="row"
                  style={{
                    paddingRight: "30px",
                    gap: "10px",
                    flexWrap: "nowrap",
                  }}
                >
                  <Grid item md={2}></Grid>
                  <Grid item md={2}>
                    <Button
                      variant="contained"
                      size="medium"
                      id="submitButton"
                      className={`btn-orange`}
                      onClick={handleSumbit}
                      onKeyDown={(e) =>
                        navigation3(e, "pdfButton", "toCancelDate", () => { })
                      }
                    >
                      Submit
                    </Button>
                  </Grid>
                  <Grid item md={2}>
                    <Button
                      variant="outlined"
                      size="medium"
                      id="pdfButton"
                      className="btn-orange-outline"
                      onClick={() => {
                        handleSumbit(1);
                      }}
                      onKeyDown={(e) =>
                        navigation3(e, "excelButton", "submitButton", () => {
                          handleSumbit(1);
                        })
                      }
                    >
                      PDF
                    </Button>
                  </Grid>
                  <Grid item md={2}>
                    <Button
                      variant="outlined"
                      size="medium"
                      className="btn-orange-outline"
                      onClick={() => {
                        handleSumbit(2);
                      }}
                    >
                      Excel
                    </Button>
                    <ReactHtmlTableToExcel
                      id="excelButton"
                      table="tables"
                      filename={"POS Transaction Report"}
                      sheet="sheet 1"
                      buttonText="EXCEL"
                      className="excel-button"
                    />
                  </Grid>

                  <Grid item md={2}>
                    <Button
                      variant="outlined"
                      size="medium"
                      id="csvButton"
                      className="btn-orange-outline"
                      onClick={() => handleSumbit(2, `csv`)}
                      onKeyDown={(e) =>
                        navigation3(e, "resetButton", "excelButton", () => {
                          handleSumbit(`csv`);
                        })
                      }
                    >
                      CSV
                    </Button>
                  </Grid>
                  <Grid item md={2}>
                    <Button
                      variant="outlined"
                      size="medium"
                      id="resetButton"
                      className="btn-orange-outline"
                      onClick={() => handleResetValue()}
                      onKeyDown={(e) =>
                        navigation3(e, "", "csvButton", () => {
                          handleResetValue();
                        })
                      }
                    >
                      RESET
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </>
        ) : (
          <PosTransactionReportTable
            reportTableData={reportTableData}
            handleBack={() => {
              setShowReport(false);
              setReportTableData({});
            }}
          />
        )}
        <Table id="tables" style={{ display: "none" }}>
          <ExcelTable
            selData={reportTableData?.header}
            fromDate={fromDate}
            toDate={toDate}
            reportsData={reportTableData?.data}
            reportData1={reportTableData?.data1}
            selUser={selUser}
            selectedData={selectedData}
          />
        </Table>
        {isPdfLoaded && (
          <>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                padding: "16px 16px 16px 0px",
                justifyContent: "flex-end",
                alignItems: "flex-end",
                gap: "10px",
                height: "76px",
              }}
            >
              <div style={{ position: "relative" }}>
                <Button
                  variant="outlined"
                  size="medium"
                  className={`btn-orange-outline`}
                  onClick={() => setIsPdfLoaded(false)}
                >
                  Back
                </Button>
              </div>
            </Box>
            <object
              id="output"
              type="application/pdf"
              width="100%"
              height="350"
              title="MTLPL - BusCRS - Agent Voucher Report"
              aria-label="MTLPL - BusCRS - Agent Voucher Report"
            ></object>
          </>
        )}
      </Box>
      {showAlert && (
        <Alert
          msg={alertMsg}
          alertType={alertType}
          close={handleAlertClose}
          buttonText="Ok"
        />
      )}
    </>
  );
};

export default PosTransactionReport;
